import $ from 'jquery'
import store_fiche from "@/store/mods/consultations/fiche-consultations"

export default {
    name: 'manage-ordonnance-lunettes',
    components: {},
    props: {
        evolution_id: Number,
        consultation_id: Number,
        user_id: Number,
        info_user: Object,
        group_id: Number,
        grs_toggler: Number,
        selected_ordonnance: Array,
        data_to_be_deleted: Object
    },
    data() {
        return {
            save_loading: false,
            is_loading: true,
            ordonnance_data: {
                v_model: []
            },
            fields: [
                'od_vdl_axe', 'od_vdl_cyl', 'od_vdl_sph',
                'og_vdl_axe', 'og_vdl_cyl', 'og_vdl_sph',
                'od_vdp_axe', 'od_vdp_cyl', 'od_vdp_sph',
                'og_vdp_axe', 'og_vdp_cyl', 'og_vdp_sph',
                'type_verre', 'type_verre_autre', 'opt_photochromique', 
                'opt_antireflet', 'opt_teinte', 'opt_autre', 
                'ecart_pup_vp', 'ecart_pup_vl', 
                'od_vdp_addition', 'og_vdp_addition'
            ],

            field_name: [
                'od_vdl_axe', 'od_vdl_cyl', 'od_vdl_sph',
                'og_vdl_axe', 'og_vdl_cyl', 'og_vdl_sph',
                'od_vdp_axe', 'od_vdp_cyl', 'od_vdp_sph',
                'og_vdp_axe', 'og_vdp_cyl', 'og_vdp_sph',
                'type_verre', 'type_verre_autre', 'opt_photochromique', 
                'opt_antireflet', 'opt_teinte', 'opt_autre', 
                'ecart_pup_vp', 'ecart_pup_vl'
            ],

            is_error: false,
            permission_is_denied: false,
            del_loading: false,
            is_confirm: false,
        }
    },

    watch : {
        async grs_toggler() {
            await this.fill_sup_fields()
            await this.initFields()
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        initFields() {
            this.is_loading = true
            this.ordonnance_data = {
                v_model: []
            }
            
            var i = 0
            
            this.fields.forEach((fld, index) => {
                var v = ''
                if (this.selected_ordonnance.length > 0) {
                    v = this.selected_ordonnance[index]['field_content']
                } 
                
                this.ordonnance_data.v_model.push({
                    field_name: fld,
                    value: v
                })
                i++

                if (i == (this.fields.length - 1)) {
                    
                    this.is_loading = false
                }
            });
        },

        fill_sup_fields() {
            const f_len = this.fields.length
            const v_len = this.selected_ordonnance.length

            if (f_len > v_len) {
                const complete_len = f_len - v_len
                //  Remplissage des champs vides
                for (let i = 0; i < complete_len; i++) {
                    this.selected_ordonnance.push({
                        field_name: this.fields[v_len + i],
                        value: ''
                    })
                }
            }
        },

        saveOrdonnanceLunette() {
            this.permission_is_denied = false
            this.is_error = false

            let data = {
                group_id: this.group_id,
                consultation_id: this.consultation_id,
                evolution_id: this.evolution_id,
                user_id: this.user_id,
                user: this.info_user,
                data_type: 'ordonnance_lunettes',
                champs: this.ordonnance_data.v_model
            }
            this.save_loading = true

            store_fiche.saveConsultationFicheSectionData(data).then((response) => {
                if (response.success) {
                    this.$refs.mdl_ordl.click()
                    this.$emit('emitRefreshOrdonnanceLunette')
                    this.successToast(response.message)

                } else {
                    this.err_message = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.$refs.mdl_ordl.click()
                this.errorToast("Une erreur s'est produite !")
            })
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimerOrdonnance(selector) {
            let confirm = document.getElementById(selector);

            if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé la suppression
                $('.err-msg').fadeIn(500)
                return
            }

            this.del_loading = true

            this.$store.dispatch('deleteAntecedent', this.data_to_be_deleted).then((response) => {
                if (response > 0) {
                    this.successToast('Suppression effectuée avec succès !')
                    this.$emit("emitRefreshOrdonnanceLunette")

                    this.$refs.del_grp_ordl.click()
                } else if (response === -2) {
                    this.permission_is_denied = true
                }

                
                this.del_loading = false;
                this.is_confirm = false
                this.btn_disable = false
            }).catch(() => {
                this.del_loading = false
                this.is_error = true
            })
        }
    }
}